module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page projects"
  }, [(_vm.featured) ? _c('div', {
    staticClass: "projects__featured"
  }, [(_vm.isVimeo(_vm.featured.content[0])) ? _c('vimeo-embed', {
    attrs: {
      "url": _vm.featured.content[0]
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('transition-group', {
    attrs: {
      "name": "project-item",
      "tag": "div"
    }
  }, _vm._l((_vm.projects), function(project) {
    return _c('div', {
      key: project.id,
      staticClass: "project-item"
    }, [_c('project-banner', {
      attrs: {
        "project": project
      }
    })], 1)
  }), 0)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e1d7fbc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Projects.vue
// module id = 113
// module chunks = 0